/**
 * Astuce affichée sur les champs OBLIGATOIRES de la déclaration dont l'information peut être
 * inconnue au moment de la saisie (identité d'une victime, immatriculation ou nom d'un
 * adversaire, conducteur…).
 *
 * Objectif : ne pas bloquer l'enregistrement du dossier quand l'agent n'a pas encore
 * l'information — elle sera corrigée plus tard depuis le détail du sinistre.
 */
export const TIP_INCONNU =
    "Information non connue ? Saisissez « INCONNU » pour enregistrer la déclaration et poursuivre. Vous pourrez la corriger plus tard depuis le dossier.";
